export const animationsTextContent = {
  headingText: "Animations",
  paraText: "Our sophisticated and state-of-the-art slot designs and captivating animations transform your slot game into a visual masterpiece. From vibrant spinning reels to unique symbol designs, from character animations to immersive gameplay, we focus on bringing the game closer to reality.",
  btnText: "View All Games",
  imageSrc: "/assets/stock-img/animations_img.webp",
};
